export default __webpack_public_path__ + "static/media/000_wurz.ec7cf468.webp";